<template>
  <div class="d-flex flex-column gap16">
    <div>
      <label class="fsp16 fw-medium text-black mb8 d-block">
        {{ this.$t('views.P2P.Swaps.14') }}
      </label>
      <SelectSimple
        id='active' 
        :dataValue='this.fields.active' 
        @updateParentState="this.updateState" 
        :keywords.sync='this.keywords1' 
        :hotUpdate="true"
        :defaultValue="this.$t('views.P2P.Swaps.38')"
        :isFilterSelect="true"
        class="w-100"
      />
    </div>
    <div>
      <label class="fsp16 fw-medium text-black mb8 d-block">
        {{ this.$t('views.P2P.Swaps.19') }}
      </label>
      <SelectSimple 
        id='internal_direction' 
        :dataValue='this.fields.internal_direction' 
        @updateParentState="this.updateState" 
        :keywords.sync='this.keywords2' 
        :hotUpdate="true"
        :defaultValue="this.$t('views.P2P.Swaps.39')"
        :isFilterSelect="true"
        class="w-100"
      />
    </div>
    <div>
      <label class="fsp16 fw-medium text-black mb8 d-block">
        {{ this.$t('views.P2P.Swaps.21') }}
      </label>
      <SelectSimple 
        id='internal_curr'
        :keywords.sync='this.curr_list'
        :dataValue='this.fields.internal_curr'
        :isSearch="true"
        @updateParentState="this.updateState"
        :hotUpdate="true"
        :defaultValue="this.$t('views.P2P.Swaps.40')"         
        :isFilterSelect="true"
        class="w-100"
      />
    </div>
    <div>
      <label class="fsp16 fw-medium text-black mb8 d-block">
        {{ this.$t('views.P2P.Swaps.20') }}
      </label>
      <SelectSimple 
        id='external_type' 
        :dataValue='this.fields.external_type' 
        :isSearch="true" 
        @updateParentState="this.updateState" 
        :keywords.sync='this.external_curr' 
        :hotUpdate="true"
        :defaultValue="this.$t('views.P2P.Swaps.41')"
        :isFilterSelect="true"
        class="w-100"
      />
    </div>
  </div>
</template>

<script>
import SelectSimple from '@/components/service/SelectSimple'

export default {
  name: 'AdsFilters',
  components: {
    SelectSimple
  },
  props: {
    initialFilters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      curr_list: [],
      external_curr: [],
      keywords1: [
        {'code': '1', value: 'Active'},
        {'code': '0', value: 'Inactive'},
      ],
      keywords2: [
        {'code': 'Maker2taker', value: "Maker2taker"},
        {'code': 'Taker2maker', value:"Taker2maker"},
      ],
      fields: {
        active: '-1',
        internal_curr: '-1',
        external_type: '-1',
        internal_direction: '-1'
      }
    }
  },
  created() {
    this.getCurrs();
    this.getExternalTypes();
    // Применяем начальные фильтры если они переданы
    if (this.initialFilters && Object.keys(this.initialFilters).length > 0) {
      this.fields = { ...this.fields, ...this.initialFilters };
    }
  },
  methods: {
    updateState(state) {
      this.fields[state.id] = state.value;
      // НЕ эмитим filterUpdate - изменения только локальные
    },
    getCurrs() {
      this.axios.post('GetListCurr', {no_loader: true, data: {}}).then(res => {
        if (res.data.body.result &&  res.data.body.result !== '0') {
          return;
        }
        let l = res.data.body;

        if(l.length != 0) {
          l.forEach(e => {
            e['value'] = e.full_name;         
          });
          this.curr_list = l;
        }
      })
    },
    getExternalTypes() {
      // DELTA: disabled
      // this.axios.post('GetlistExterlanTypes', {no_loader: true, data: {}}).then(res => {
      //   if (res.data.body.external_types) {
      //     let l = res.data.body.external_types.tables[0].colvalues;
      //     l.forEach(e => {
      //       e['value'] = e.name;
      //     });
      //     this.external_curr = l;
      //   }
      // });
    },
    clearFilters() {
      this.fields.active = '-1';
      this.fields.internal_curr = '-1';
      this.fields.external_type = '-1';
      this.fields.internal_direction = '-1';
      // НЕ эмитим filterUpdate - изменения только локальные
    },
    applyFilters() {
      // Эмитим текущие фильтры при применении
      this.$emit('filterUpdate', this.fields);
    }
  }
}
</script>
